import { bakimHesapla } from '../utils/bakimHesapla';

interface OzetCustomer {
  id: string;
  adSoyad: string;
  telefon: string;
  ilce: string;
  il: string;
  cihazTuru: string;
  sonBakimTarihi: string;
}

interface Props {
  customers: OzetCustomer[];
  onFilter: (f: 'hepsi' | 'yesil' | 'sari' | 'turuncu' | 'kirmizi') => void;
  aktifFilter: string;
}

export default function BakimOzetKartlar({ customers, onFilter, aktifFilter }: Props) {
  const yesil = customers.filter(c => c.sonBakimTarihi && bakimHesapla(c.sonBakimTarihi).durum === 'yesil').length;
  const sari = customers.filter(c => c.sonBakimTarihi && bakimHesapla(c.sonBakimTarihi).durum === 'sari').length;
  const turuncu = customers.filter(c => c.sonBakimTarihi && bakimHesapla(c.sonBakimTarihi).durum === 'turuncu').length;
  const kirmizi = customers.filter(c => c.sonBakimTarihi && bakimHesapla(c.sonBakimTarihi).durum === 'kirmizi').length;
  const toplam = customers.length;

  const kartlar = [
    { key: 'hepsi' as const, label: 'Tüm Müşteriler', sayi: toplam, ikon: 'ri-group-line', iconBg: 'bg-slate-100', iconColor: 'text-slate-600', textColor: 'text-gray-800', activeBg: 'bg-slate-700', activeText: 'text-white' },
    { key: 'yesil' as const, label: 'Bakım Süresi Uygun', alt: '< 6 ay', sayi: yesil, ikon: 'ri-checkbox-circle-line', iconBg: 'bg-emerald-100', iconColor: 'text-emerald-600', textColor: 'text-emerald-700', activeBg: 'bg-emerald-600', activeText: 'text-white' },
    { key: 'sari' as const, label: 'Bakım Zamanı Geldi', alt: '6 - 9 ay', sayi: sari, ikon: 'ri-time-line', iconBg: 'bg-yellow-100', iconColor: 'text-yellow-600', textColor: 'text-yellow-700', activeBg: 'bg-yellow-500', activeText: 'text-white' },
    { key: 'turuncu' as const, label: 'Bakım Gecikiyor', alt: '9 - 12 ay', sayi: turuncu, ikon: 'ri-alert-line', iconBg: 'bg-orange-100', iconColor: 'text-orange-600', textColor: 'text-orange-700', activeBg: 'bg-orange-500', activeText: 'text-white' },
    { key: 'kirmizi' as const, label: 'Kritik Gecikme', alt: '> 12 ay', sayi: kirmizi, ikon: 'ri-alarm-warning-line', iconBg: 'bg-red-100', iconColor: 'text-red-600', textColor: 'text-red-700', activeBg: 'bg-red-500', activeText: 'text-white' },
  ];

  return (
    <div className="grid grid-cols-2 lg:grid-cols-5 gap-4">
      {kartlar.map(k => {
        const isActive = aktifFilter === k.key;
        return (
          <button key={k.key} onClick={() => onFilter(k.key)}
            className={`rounded-xl p-4 border text-left transition-all duration-200 cursor-pointer w-full
              ${isActive ? `${k.activeBg} border-transparent shadow-md` : `bg-white border-gray-200 hover:shadow-sm`}`}>
            <div className="flex items-start justify-between gap-1">
              <div>
                <p className={`text-2xl font-bold ${isActive ? k.activeText : k.textColor}`}>{k.sayi}</p>
                <p className={`text-xs font-semibold mt-0.5 ${isActive ? 'text-white/90' : 'text-gray-700'}`}>{k.label}</p>
                {k.alt && <p className={`text-[10px] mt-0.5 ${isActive ? 'text-white/70' : 'text-gray-400'}`}>{k.alt}</p>}
              </div>
              <div className={`w-9 h-9 flex items-center justify-center rounded-lg flex-shrink-0 ${isActive ? 'bg-white/20' : k.iconBg}`}>
                <i className={`${k.ikon} text-lg ${isActive ? 'text-white' : k.iconColor}`}></i>
              </div>
            </div>
            {toplam > 0 && k.key !== 'hepsi' && (
              <div className={`mt-2 h-1 rounded-full ${isActive ? 'bg-white/30' : 'bg-gray-100'}`}>
                <div className={`h-1 rounded-full transition-all ${isActive ? 'bg-white/80' : k.iconColor.replace('text-', 'bg-')}`}
                  style={{ width: `${Math.round((k.sayi / toplam) * 100)}%` }} />
              </div>
            )}
          </button>
        );
      })}
    </div>
  );
}